import axios from 'axios';
import { defineStore } from 'pinia';

import { formStore } from '@/stores/form';
import { pakketStore } from '@/stores/pakket';
import { vragenStore } from "@/stores/vragen.js";

export const voertuigStore = defineStore({
  id: 'voertuig',
  state: () => ({
    aankoopwaarde: '',
    acceleratiesnelheid: '',
    accessoires: '',
    accessoireswaarde: '',
    alarmklasse: '',
    beveiliging: '',
    Bouwdatum: '',
    bouwjaar: '',
    bouwmaand: '',
    bpm_bedrag: '',
    brandstof_soort: '',
    berekende_soort: '',
    berekende_funnel: '',
    carrosserie: '',
    cataloguswaarde: '',
    cataloguswaarde_ex_btw: '',
    cataloguswaarde_ex_btw_en_bpm: '',
    cataloguswaarde_manual: false,
    cilinderinhoud: '',
    cilinderinhoud_manual: false,
    dagelijks_gebruik: '',
    dagwaarde: '',
    dagwaarde_ex_btw: '',
    dagwaarde_manual: false,
    eerste_toelating_nationaal: '',
    foto: '',
    gebruikt_als_taxi: false,
    gewicht: '',
    gewicht_manual: false,
    in_gebruik_als_taxi: false,
    kenteken: '',
    kentekenOnbekend: false,
    manualinput: false,
    MaximumConstructiesnelheid: '',
    meldcode: '',
    meldcode_vragen_klant: false,
    merk: '',
    merk_id: '',
    model: '',
    model_id: '',
    slot: '',
    soort: '',
    status: '',
    transmissie: '',
    transmissie_soort: '',
    three_wheel_vehicle_type: '',
    type: '',
    type_id: '',
    type_id_correct: true,
    vehicleload: '',
    vermogen: '',
    vermogen_manual: false,
    bouwaard: '',
  }),
  getters: {
    getHasVehicle() {
      return this.type || this.model;
    },
    getBrandAndType() {
      return this.merk && this.type ? `${this.merk} ${this.type}` : null;
    },
    getType() {
      // Depending on the type of vehicle, the type is either the type or the model
      // This is due to the Laravel API returning the type as the model for some vehicles
      switch (this.soort.toLowerCase()) {
        case 'personenauto':
        case 'bestelauto':
        case 'kampeerauto':
        case 'caravan':
        case 'mmbs':
        case 'stacaravan':
        case 'toercaravan':
        case 'toercaravan-met-kenteken':
        case 'vouwwagen':
        case 'vouwwagen-met-kenteken':
          return this.model;
        default:
          return this.type;
      }
    },
    getBrandType() {
      return this.merk ? `${this.merk} ${this.getType}` : null;
    },
    getIsTaxi() {
      return this.gebruikt_als_taxi || this.in_gebruik_als_taxi;
    },
  },
  actions: {
    setSoort(value) {
      switch (value) {
        case 'auto':
          this.soort = 'personenauto';
          break;

        case 'camper':
          this.soort = 'kampeerauto';
          break;

        case 'AutomaatOfScooter':
        case 'Brommobiel':
        case 'HighSpeedEBike':
        case 'FietsMetHulpmotor':
        case 'Versneller':
          this.soort = 'bromfiets';
          break;

        default:
          this.soort = value;
          break;
      }
    },
    setInitialSoort(value) {
      if (this.soort === '') {
        this.setSoort(value);
      }
    },
    async fetchVoertuigData(kenteken) {
      const form = formStore();
      const vragen = vragenStore();
      form.setBaseSpinner(true);
      const licensePlate = kenteken.replaceAll('-', '');
      return axios
        .post('voertuig/kenteken', {
          kenteken: licensePlate,
        })
        .then((response) => {
          response.data.kenteken = response.data.kenteken.replaceAll('-', '');
          const pakket = pakketStore();

          if (
            form.voertuigSoortOriginal === response.data.berekende_funnel ||
            (form.voertuigSoortOriginal === 'auto' &&
              (response.data.berekende_funnel === 'personenauto' || response.data.berekende_funnel === 'bestelauto'))
          ) {
            // Set type module in voordeelpakket
            pakket.setModule(response.data.berekende_funnel);
          }

          if (response.data.berekende_funnel === 'bestelauto') {
            // Set bpmVerrekenen ticket: WEBDEV-1537
            const bpmVerrekenen = response.data.bouwjaar < 2025;
            vragen.setBpmVerrekenen(bpmVerrekenen);
          }

          return response.data;
        })
        .catch(() => {})
        .finally(() => {
          form.setBaseSpinner(false);
        });
    },
    async fetchMMBSData(kenteken) {
      const form = formStore();
      form.setBaseSpinner(true);
      const licensePlate = kenteken.replaceAll('-', '');
      return axios
        .post('kentekencheck-rdw', {
          kenteken: licensePlate,
        })
        .then((response) => {
          response.data.kenteken = response.data.kenteken.replaceAll('-', '');
          return response.data;
        })
        .catch(() => {})
        .finally(() => {
          form.setBaseSpinner(false);
        });
    },
    resetVoertuig() {
      const form = formStore();

      let tempKentekenOnbekend = this.kentekenOnbekend;
      let tempMeldcodeVragenKlant = this.meldcode_vragen_klant;
      let tempSoort = this.soort;

      form.voertuigMerken = null;
      form.voertuigModels = null;
      form.voertuigTypes = null;
      this.$reset();

      this.kentekenOnbekend = tempKentekenOnbekend;
      this.meldcode_vragen_klant = tempMeldcodeVragenKlant;
      this.setSoort(tempSoort);
    },
  },
  persist: true,
});
